import { render } from "./CourseChapterDesign.vue?vue&type=template&id=e5a95b06&scoped=true"
import script from "./CourseChapterDesign.vue?vue&type=script&lang=js"
export * from "./CourseChapterDesign.vue?vue&type=script&lang=js"

import "./CourseChapterDesign.vue?vue&type=style&index=0&id=e5a95b06&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a95b06"]])

export default __exports__